import { Tooltip, TooltipTrigger } from "@repo/ui/components/tooltip";
import { forwardRef } from "react";
import { ShellTooltipContent } from "./shell-tooltip";
import type { IconComponent } from "@repo/ui/types/icon";
import { cn } from "@repo/ui/lib/utils";

export function Toolbar({ children }: { children?: React.ReactNode }) {
  return (
    <div className="fixed bottom-4 right-4 z-10">
      <div className="p-0 bg-primary rounded-full shadow-lg flex items-center justify-center">
        {children}
      </div>
    </div>
  );
}

export const ToolbarButton = forwardRef<
  HTMLButtonElement,
  {
    icon: IconComponent;
    label: string;
    variant?: "default" | "destructive";
  } & React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ icon: Icon, label, variant = "default", ...props }, ref) => {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <button
          ref={ref}
          aria-label={label}
          className={cn(
            "p-3 rounded-full bg-primary/95 text-button-primary-foreground hover:bg-primary active:bg-primary",
            variant === "destructive" && "text-destructive"
          )}
          {...props}
        >
          <Icon size={16} color="currentColor" className="text-inherit" />
        </button>
      </TooltipTrigger>
      <ShellTooltipContent>
        <span>{label}</span>
      </ShellTooltipContent>
    </Tooltip>
  );
});
ToolbarButton.displayName = "ToolbarButton";
